import React, { useState, useEffect } from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, TextField } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import Modal from '@material-ui/core/Modal';


// Generate Order Data
// function createData(nr, auction_id, auction_type, from, to, pickup_date, delivery_date, price, bids, percent ) {

//   return { nr, auction_id, auction_type, from, to, pickup_date, delivery_date, price, bids, percent };
  
  
// }

//   const rows = [
//   createData(1, '#73091', 'Removals', '60436 Frankfurt', 'D - Kassel', '01.12.2021', '08.12.2021', '€3000', 'Bid', '10%'),
//   createData(2, '#73092', 'Vehicle transport', 'Z5108 London, UK', 'D - Stoke', '27.12.2020', '01.02.2021', '€3500', 'Bid', '15%'),
//    createData(3, '#73093', 'Vehicle transport', '60446 Köln', '56789 Berlin', '11.11.2020', '27.12.2020', '€2000', 'Bid', '15%'),
//    createData(4, '#73094', 'Container', '60446 Köln', '56789 Berlin', '15.12.2020', '27.12.2020', '€3800', 'Bid', '12%'),
//    createData(5, '#73095', 'Container', '60446 Köln', '56789 Berlin', '20.01.2021', '28.12.2020', '€5000', 'Bid', '16%')
//  ];



// function preventDefault(event) {
  
//   event.preventDefault();
  
// }

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },

  tabelHeader: {
    color: '#303F9F',
  },

  tableRowsTypo: {
    fontSize: '0.75rem'
  },

  paper: {
    margin: 'auto',
    // position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));






const  AuctionsTable = () => {
  const classes = useStyles();
  const [auctions, setAuctions] = useState(null)
  
  useEffect(() => {
   fetch("/api/auctions")
   .then((res) => res.json())
  //  .then((data) => console.log(data))
  .then((data) => setAuctions(data))
   .catch((error) => console.log('Auctions not fetched'))
   //console.log(auctions)
  }, []);


  // <---- START Bid function ---->
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
// <---- END Bid function ---->

//<---- START save bid price ---->
const [ bidInput, setBidInput] = useState(null)
const [ bidPrice, setbidPrice ] = useState(null)
const [ bidIndex , setBidIndex ] = useState(null)
//<---- START save bid price ---->

  
  return (
    <>
      <Title>Ongoing Auctions</Title>
      <Table size="small">
        <TableHead>
          <TableRow>

            <TableCell className={classes.tabelHeader}>Auction ID.</TableCell>
            <TableCell className={classes.tabelHeader}>Volume</TableCell>
            <TableCell className={classes.tabelHeader}>Auction Type</TableCell>
            <TableCell className={classes.tabelHeader}>From</TableCell>
            <TableCell className={classes.tabelHeader}>To</TableCell>
            <TableCell className={classes.tabelHeader}>Pick up Date</TableCell>
            <TableCell className={classes.tabelHeader}>Delivery date</TableCell>
            <TableCell className={classes.tabelHeader}>Price</TableCell>
            <TableCell className={classes.tabelHeader}>Bids </TableCell>
            <TableCell className={classes.tabelHeader}>%</TableCell>
            {/* <TableCell align="right">Sale Amount</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {auctions && auctions.map((auction, i) => {
            return (
            <TableRow key={i}>
              <TableCell className={classes.tableRowsTypo}>#00{auction.id}</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.volume}cbm</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.category}</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.move_from_city}</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.move_to_city}</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.move_on}</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.deliver_on}</TableCell>
              <TableCell className={classes.tableRowsTypo}>{auction.bid_amount}€</TableCell>
              <TableCell className={classes.tableRowsTypo}>{i === bidIndex ? bidPrice : ''}€</TableCell>
                {/* <TableCell onClick={handleOpen} className={classes.tableRowsTypo}>Bid</TableCell> */}
                <TableCell onClick={() => { handleOpen(); setBidIndex(i);}} className={classes.tableRowsTypo} style={{cursor: 'pointer', color: 'red'}}>Bid</TableCell>
                <Modal style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  >
                  <div className={classes.paper}>
                    <TextField onChange={(e) => setBidInput(e.target.value)}  id="outlined-basic" label="Enter amount" variant="outlined" />
                    <Button variant="contained" color="primary" style={{padding: '1rem'}} onClick={() => setbidPrice(bidInput)}>
                      Place bid
                    </Button>
                  </div>
                </Modal>
              <TableCell className={classes.tableRowsTypo}>{auction.percent}</TableCell>
            </TableRow>
          )})}
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        <Link color="primary" href="#" >
          See more auctions
        </Link>
      </div>    
    </>
  );
}


export default AuctionsTable;
